import type { ReviewCard } from '@/api/review'
import type { UserWordSummary } from '@/types/user'

export function userWordToReviewCard(word: UserWordSummary): ReviewCard {
  const isPhrase = word.unitKind === 'PHRASE'
  return {
    id: word.id,
    wordId: word.wordId,
    word: word.word,
    translation: word.translation,
    phonetic: word.phonetic,
    audioUrl: word.audioUrl,
    partOfSpeech: word.partOfSpeech,
    cefrLevel: word.cefrLevel,
    examples: [],
    mode: 'CLASSIC',
    questionText: word.word,
    answerText: word.translation,
    unitType: isPhrase ? (word.phraseUnitType ?? 'PHRASE') : 'WORD',
  }
}

export function cloneReviewCardForRetry(card: ReviewCard): ReviewCard {
  return {
    ...card,
    id: `${card.id}-retry-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
  }
}
